import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22_app.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22../assets/fonts/GopherText-Bold.woff2%22,%22weight%22:%22700%22,%22style%22:%22normal%22,%22display%22:%22swap%22}],%22variableName%22:%22gopher%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'gopher', 'gopher Fallback'",
        fontWeight: 700,
fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
